<template>
    <div class="ChatWindow">
        <div class="ChatWindow__in" ref="ChatWindowMessageWrap">
          <div v-for="(item, i) in messages" class="messageWrapper" :id="item.uid">
              <Message
                v-if="item.type=='user'"
                :id="item.id"
                :key="i"
                :data="{
                  img:item.picture,
                  name:item.title,
                  watched:item.watched,
                  files:item.files,
                  time:item.dataStamp,
                  text:item.text,
                }"
                @watched="watched"
              />
            <Offer
              :params="item?.response"
              :watched ="item.watched"
              :id="item.id"
              v-else-if="item.type=='systemResponse'"
              @watched="watched"
            />
            <div class="date"  v-else-if="item.type=='date'">
              {{item.text}}
            </div>
            <pre v-else-if="item.uid!=''">
              {{item}}
            </pre>
          </div>
        </div>
        <ChatControls :messages="langMessage" @send="send" v-if="!!params && params?.writable!==false"/>
    </div>
</template>

<script>
import {computed, nextTick, ref, watch} from "vue";
import Offer from "./Offer";
import ChatControls from "./ChatControls";
import Message from "./Message";
import FileMessage from "./FileMessage.vue";
import map from "lodash/map";
import Helpers from '../../libs/Helpers'

export default {
    name: "ChatWindow",
    components: {Message, ChatControls, Offer,FileMessage},
    emits:['addMessage','showMore'],
    props:['params','langMessage'],
    methods:{
        scrollBottom() {
          let objDiv = this.$refs.ChatWindowMessageWrap;
          const header = document.querySelector('.header')
            document.querySelector('.ChatWindow').scrollIntoView();
            window.scrollTo(0, window.scrollY - header.clientHeight || 100) // 100 - header height
            setTimeout(() => {
                objDiv.scrollTo(0, objDiv.scrollHeight);
            }, 10)

        }
    },
    setup(props, ctx) {
        const helpers = new Helpers()
        let send = (e)=>{
          ctx.emit('addMessage',e);
        }
        const lastMessageId = ref(null);
        const ChatWindowMessageWrap = ref(null);
        const messages = computed(()=>{
          let res = [];
          const arMsg = props.params?.MESSAGES?.ITEMS.map((item, index) => {
              return {...item, ...{indexOriginal: index}}
          })
          let prevElement = false;
          for(let index in arMsg) {
            if(prevElement!==false) {
              if(prevElement.dataDayText!==arMsg[index].dataDayText) {
                res.push({
                  "type": "date",
                  "text": arMsg[index].dataDayText
                });
              }

            }
            res.push(arMsg[index]);
            prevElement = arMsg[index];
          }
          return res.map((item, key) => {
              const id = item.id || ''
              const text = item.text || ''
              const ts = item.time || item.dataStamp || ''
              const uid = helpers.b64EncodeUnicode(id + text + ts)
              return {...item, ...{uid}}
          });
        });
        watch(props.params?.MESSAGES, (value, oldValue) => {
          if(true) {
            if(value.ITEMS[value.ITEMS.length-1]?.id>lastMessageId.value) {
              nextTick(()=>{
                ChatWindowMessageWrap.value.scrollTop = ChatWindowMessageWrap.value.scrollHeight;
              })
              lastMessageId.value = value.ITEMS[value.ITEMS.length-1].id;
            }
          }
        })
        const watched = async (target) => {
            let data = props.params.api.watchedMessage.data;
            data['id'] = target;
            const { status, data: responseData } = await axios.post(props.params.api.watchedMessage.link, data);
        }
        return {
          send,
          watched,
          lastMessageId,
          ChatWindowMessageWrap,
          messages
        }
    },
    mounted: function () {
      this.lastMessageId = 0;
      if(this.params?.MESSAGES?.ITEMS) {
        this.lastMessageId = this.params?.MESSAGES?.ITEMS[this.params?.MESSAGES?.ITEMS?.length-1].id;
      }

      let objDiv = this.$refs.ChatWindowMessageWrap;
      this.ChatWindowMessageWrap = this.$refs.ChatWindowMessageWrap;
      objDiv.scrollTop = objDiv.scrollHeight;
      objDiv.addEventListener("scroll", (event) => {
        if((objDiv.scrollTop - 100) < 0 && this.params.MESSAGES.PAGEN.nextPage) {
            const firstChatElementId = document.querySelectorAll('.messageWrapper')[0].id
            this.$emit('showMore',{page: this.params.MESSAGES.PAGEN.nextPage, scrollElementId: firstChatElementId});
        }
      });

    },
}
</script>

<style scoped lang="scss">
.ChatWindow {
    background-color: #fff;
    padding: 0 rem(35);
    padding-top: rem(25);
    min-height: calc(100vh - rem(250));
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: rem(30);
    scroll-margin-top: 100px;
    scroll-padding-top: 100px;

    @include mobile {
        padding: 0 rem(15);
        height: calc(100vh - 150px);
        width: 100%;
    }

    &__in {
        flex: 1;
        overflow: auto;
        max-height: calc(100vh - rem(150));
    }

    .date {
        font-weight: 700;
        font-size: rem(16);
        line-height: rem(24);
        text-align: center;
        margin-bottom: rem(25);
        margin-top: rem(25);
    }
}
</style>